import { Component, Input } from "@angular/core";
import { Chip } from "./chip";
import { LayoutDirective, LayoutAlignDirective } from "@ngbracket/ngx-layout/flex";
import { ForgeChipModule, ForgeChipSetModule } from "@tylertech/forge-angular";

@Component({
    selector: "chip-collection",
    templateUrl: "./chipCollection.tmpl.html",
    imports: [
        LayoutDirective,
        LayoutAlignDirective,
        ForgeChipSetModule,
        ForgeChipModule,
    ]
})
export class ChipCollectionComponent
{
    @Input() readonly chips: ReadonlyArray<Chip>;
}
